import { Channel } from '@models/channel';
import { ObjectHelper } from '@utilities/object-helper';

/**
 * This is the measured telemetry data about a specific channel
 */
export class ChannelData extends Channel {
  power: number;
  bandwidth: number;
  mer: number;
  preBER: number;
  postBER: number;
  snr: number;
  portSnr: number;
  rxPwr: number;
  coefficient: string;

  /**
   * Empty constructor is used.  Creating the constructor to indicate it's usage, even though there is no custom logic in the function
   */
  constructor() {
    super();
  }

  static getChannelDataFromHttpResponse(httpResponse: any): ChannelData[] {
    const channelList: ChannelData[] = ObjectHelper.copyArray(httpResponse, ChannelData);
    channelList.map((channel, index) => {
      channel.frequency = httpResponse[index]['freq'];
      channel.power = httpResponse[index]['power'] ? httpResponse[index]['power'] : httpResponse[index]['pwr'];
    });
    return channelList;
  }
}

